module.exports = __webpack_public_path__ + "img/food-ticket.cfe96a8d.svg";